module.exports = __webpack_public_path__ + "fonts/codicon.f5ac4551.ttf";